module.exports = __webpack_public_path__ + "static/media/pets.7edf57a8.png";